import React, {useEffect, useState} from 'react'
import { useSelector, useDispatch, useStore } from 'react-redux'
import PageContainer from '../fragments/page-container'
import {
	action_add_newarrivals_list,
	action_fetch_newarrivals_list,
	action_fetch_newarrivals_sorters,
	action_fetch_newarrivals_filter
} from '../../../../store/actions/pages/new-arrivals'
import {
	action_fetch_list_top_banner
} from '../../../../store/actions/global'
import List from '../components/list'
import {filterItemsToString, getFilterItemsFromQuery, getTopBanner} from '../utils'
import queryString from 'query-string'
import Empty from '../components/list/empty'
import classes from '../style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import { useQuery } from '../../../hooks/common'
import { FormattedMessage } from 'react-intl'
import { useLocation } from 'react-router-dom'
import BlockImage from '../../../components/image/block-image'
import { useSensors } from '../../../hooks/sensor'
import { generateFilter } from '../../../utils/sensor'

const getValidFilterItems = items => {
	const newItems = []

	items?.forEach(item => {
		if(['color','size','tags','category'].indexOf(item.fieldName) >= 0 || item.fieldName?.indexOf('tags-') === 0){
			newItems.push(item)
		}
	})
	return newItems
}

const parseSearch = search => {
	const parsed = queryString.parse(search)
	if(parsed && parsed.sort_by){
		parsed.parentSkus = parsed.sort_by
	}
	return parsed
}

const parseParams = search => {
	if(!search) return
	let newParams = {}
	Object.keys(search).forEach(key => {
		if(search[key] instanceof Array){
			newParams[key] = search[key]?.filter((value, index, s) =>  s.indexOf(value) === index).join?.(',')
		}else{
			newParams[key] = search[key]
		}
	})

	if(search?.sort_by){
		newParams['parentSkus'] = search.sort_by
	}
	return newParams
}

const NewArrivals = props => {
	useStyles(classes)
	const dispatch = useDispatch()
	const global = useSelector(state => state.global)
	const pageNewArrivals = useSelector((state) => state.pageNewArrivals)
	const query = useQuery()
	const store = useStore()
	const {params} = props.match

	const [rangeId, setRangeId] = useState(query?.rangeId)

	const location = useLocation()

	const { listTopBanner } = global
	const banner = getTopBanner(listTopBanner, 'newarrivals')

	const search = parseSearch(location.search)
	const filterItems = getFilterItemsFromQuery(search)
	const [value, setValue] = useState(filterItems)
	const [sorter, setSorter] = useState(Number(search['sort'])||0)
	const [tag, setTag] = useState({
		fieldName: 'tags',
		selections: (search?.tags instanceof Array)?(search.tags.join(',').split(',').map(s => ({value: s}))): (search.tags?.split(',').map(s => ({value: s})))
	})

	const [min, setMin] = useState(search.minPrice && !isNaN(search.minPrice) ? Number(search.minPrice): undefined)
	const [max, setMax] = useState(search.maxPrice && !isNaN(search.maxPrice) ? Number(search.maxPrice): undefined)

	const [sensors, setSensors] = useState(useSensors())

	const filterStr = generateFilter(pageNewArrivals?.filterData, pageNewArrivals?.sorters)


	useEffect(async () => {
		if(window.__INITIAL_STATE__){
			// Allow the passed state to be garbage-collected
			delete window.__INITIAL_STATE__
		}else{
			await NewArrivals.fetchData(store, params, search, {})

			window.scrollTo({
				top: 0, 
			})

		}
	}, [location.search])


	const submitHandle = filterItems => {
		let resultSearch
		if(tag){
			if(filterItems?.some(f => f.fieldName === 'tags')){
				resultSearch = filterItemsToString(filterItems)
			}else{
				if(tag.value){
					resultSearch = filterItemsToString([...filterItems, {fieldName: 'tags', selections:[tag]}])
				}else{
					resultSearch = filterItemsToString([...filterItems])
				}
				
			}
		}else{
			resultSearch = filterItemsToString(filterItems)
		}


		if(rangeId && resultSearch?.indexOf('rangeId') < 0){
			resultSearch = `${resultSearch}&rangeId=${rangeId}`
		}
		setValue(filterItems)
		props.history.replace(`${location.pathname}?${resultSearch}`)
	}

	const handleSorter = sorter => {
		setSorter(sorter)
		props.history.replace(`${location.pathname}?${queryString.stringify({...search, sort: sorter, rangeId})}`)
	}

	const handleTag = tag => {
		setTag(tag)
		const tagSearch = {...search, tags: tag?.value, rangeId}
		props.history.replace(`${location.pathname}?${queryString.stringify(tagSearch)}`)
	}

	const onScroll = () => {
		const initialFilterItems = getFilterItemsFromQuery(search)
		const { sorters } = pageNewArrivals

		const requestSorter = (sorters instanceof Array) ? sorters?.[sorter]?.value: sorter
		const filter = {
			sorter: requestSorter,
			filterItems: getValidFilterItems(initialFilterItems),
		}

		dispatch(action_add_newarrivals_list(filter, {...search, skip: pageNewArrivals?.skip, rangeId}, {}))

	}


	return <div>
		<PageContainer links={[
			{
				href: '#',
				title: <FormattedMessage id={'new_arrivals'} defaultMessage="New Arrivals"/>
			}
		]}
		extra={() => {
			return <>
				{
					banner && banner.src && <div>
						<BlockImage sensors={{
							position: 1,
							content: banner.refId,
							type: '1',
							title: 'list'
						}} href={banner.href} title={banner.title} src={banner.src} width={banner.width} height={banner.height} />
					</div>
				}
			</>
		}}
		total={pageNewArrivals?.total}
		filterVo={pageNewArrivals?.filterVo}
		sorters={pageNewArrivals?.sorters}
		onSubmit={submitHandle}
		value={value}
		sorter={sorter}
		onSorter={handleSorter}
		onTag={handleTag}
		tag={tag}
		>
			{
				pageNewArrivals?.finished && (!pageNewArrivals?.list || pageNewArrivals?.list?.length < 1) ? <Empty/>: <List filter={filterStr} sensors={sensors} products={pageNewArrivals.list} request={onScroll} loading={pageNewArrivals?.loading} finished={pageNewArrivals?.finished}/>
			}
		</PageContainer>
	</div>
}




NewArrivals.fetchData = async (store, params, search, headers) => {

	const initialFilterItems = getFilterItemsFromQuery(search)
	const sort = search.sort || 0
	const sorters = await store.dispatch(action_fetch_newarrivals_sorters({}, headers))
	const sorter = (sorters instanceof Array) ? sorters?.[sort]?.value: sort

	const filter = {
		sorter: sorter,
		filterItems: getValidFilterItems(initialFilterItems),
	}

	const values = await Promise.all([
		store.dispatch(action_fetch_newarrivals_list(filter, {...parseParams(search), rangeId: search?.rangeId}, headers)),
		store.dispatch(action_fetch_newarrivals_filter({}, headers)),
		store.dispatch(action_fetch_list_top_banner(headers)),
	])
	return [...values, sorters]
}

export default NewArrivals
